module.exports = {
  text: `Чёртовы угре-пауки хотят сделать всех нас рабами! И нет, они не вкусные`,
  author: `Воло`,
}
